import { useCallback, useEffect } from 'react';

import { debugSelectors } from '../selectors/debugSelectors';
import { useAppSelector } from './useThunkDispatch';

export const useA11yLogInConsole = () => {
    const { a11yLogsInConsole } = useAppSelector(debugSelectors.selectDebug);

    const log = useCallback(
        (...params: Parameters<typeof console.log>) => {
            if (a11yLogsInConsole) {
                // eslint-disable-next-line no-console
                console.log('A11Y logger:', ...params);
            }
        },
        [a11yLogsInConsole],
    );

    return log;
};

export const useA11yLogInConsoleEffect = (...text: Parameters<typeof console.log>) => {
    const log = useA11yLogInConsole();

    useEffect(() => {
        if (text) {
            log(text);
        }
    }, [log, text]);
};
